import { Spacer } from 'app/member/layouts/generic';
import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { setPageTitle } from 'store/actions/header';
import { LeadsBoard } from './leads';
import { UsersBoard } from './users';
import { TenantsBoard } from './tenants';
import { CalendarBoard } from './calendar';
import { CustomersConfigBoard } from './config';

const NAV_ITEMS = [
  { title: 'Leads', path: '/customers/leads' },
  { title: 'Users', path: '/customers/users' },
  { title: 'Tenants', path: '/customers/tenants' },
  { title: 'Calendar', path: '/customers/calendar' },
  { title: 'Config', path: '/customers/config' }
];

const CustomersModule = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Customers', path: '.' }]));
  }, [dispatch]);

  return (
    <PageContentWrapper>
      <SlidingNav nav_items={NAV_ITEMS} />
      <Spacer multiple={4} />
      <Routes>
        <Route path="/" element={<Navigate to="leads" replace />} />
        <Route path="leads" element={<LeadsBoard />} />
        <Route path="users" element={<UsersBoard />} />
        <Route path="tenants" element={<TenantsBoard />} />
        <Route path="calendar" element={<CalendarBoard />} />
        <Route path="config" element={<CustomersConfigBoard />} />
      </Routes>
    </PageContentWrapper>
  );
};

export default CustomersModule;
